import React from 'react';
import { Layout as AntLayout, Col, Row, Typography } from 'antd';
import logo from 'images/bb-logo.png';
import { useDispatch, useSelector } from 'react-redux';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import LayoutNavigation from 'core/Layout/LayoutNavigation';
import { actions } from 'core/Layout/Layout.redux';
import Cookies from 'portal-cookie';
import { useParams, useLocation } from 'react-router-dom';



const { Header, Footer, Content, Sider } = AntLayout;
const year = new Date().getFullYear();



const Layout = (props) => {
	//console.log('[Layout]');
	let location = useLocation();
	//console.log('location.pathname', location.pathname);
	const isWarehouse = location.pathname.startsWith('/warehouse');
	const dispatch = useDispatch();
	const loggedIn = useSelector(state => state.auth.loggedIn);
	const title = useSelector(state => state.layout.title);
	const menuCollapsed = useSelector(state => state.layout.menuCollapsed);

	const selectedSystem = useSelector(state => state.auth.selectedSystem);
	//console.log('[Layout] selectedSystem', selectedSystem);

	const toggleShowMenu = () => dispatch(actions.setState({ menuCollapsed: !menuCollapsed }));

	let LastSystem = Cookies.get('LastSystem');
	//console.log('LastSystem', LastSystem);

	const getStyleFromSystem = (selectedSystem, baseStyle = 'ts_content') => {
		// update class on system switch
		let _sys = selectedSystem ?? LastSystem;
		// .bb_branded
		// .em_branded
		// .ab_branded // <- STEVE abyss?
		// .od_branded
		// .other_branded 

		switch (_sys) {
			case 'BB': return baseStyle + ' bb_branded'; 	// hardcoded deliberate spaces
			case 'Emblem': return baseStyle + ' em_branded';
			case 'Abyss': return baseStyle + ' ab_branded'; // <- STEVE abyss?
			case 'OnDraft': return baseStyle + ' od_branded';
			default: return baseStyle + ' other_branded';
		}
	}

	const contentClass = React.useMemo(() => getStyleFromSystem(selectedSystem), [selectedSystem]);

	return (
		<AntLayout
			className={
				contentClass
				+ (isWarehouse ? ' warehouse_padding_hack' : '') // STYLE hacky + hardcoded + deliberate space
			}>

			<Header className="ts_header">
				<Row>
					<Col>
						{
							(loggedIn && !menuCollapsed) && <MenuFoldOutlined className="ts_nav_collapse_icon" onClick={toggleShowMenu} />
						}
						{
							(loggedIn && menuCollapsed) && <MenuUnfoldOutlined className="ts_nav_collapse_icon" onClick={toggleShowMenu} />
						}
					</Col>
					<Col className="header_logo_container">
					</Col>
					<Col>
						<Typography.Title level={2} className="ts_header_title">
							{title}
						</Typography.Title>
					</Col>
				</Row>

			</Header>


			<AntLayout >
				{loggedIn &&
					<Sider trigger={null} collapsible collapsed={menuCollapsed} className="ts_sider_container">
						<LayoutNavigation />
					</Sider>
				}

				<div className="nonheader_wrapper">
					<Content >
						{props.children}
					</Content>

					<Footer id={'ts_layout_footer'} className="ts_footer" align="center">
						&copy; {year} {process.env.REACT_APP_COMPANY_NAME}. All rights reserved. &nbsp; <b>{process.env.REACT_APP_VERSION}</b>
					</Footer>
				</div>
			</AntLayout>


		</AntLayout>
	);
};


export default Layout;
